import { useState } from "react";
import { Button } from "reactstrap";
import { useAbsensi } from "../../../../Context/AbsensiContext";

const ExportAbsen = ({ year, month = null, filter }) => {
  const absensiAPI = useAbsensi();
  const [exportState, setExportState] = useState(
    month ? "Excel Absen Bulanan" : "Excel Absen Tahunan"
  );
  const [isExportDisable, setIsExportDisable] = useState(false);

  const exportAbsen = () => {
    setIsExportDisable(true)
    setExportState("Diproses...")
    absensiAPI.getAbsenExport(year, month, filter).then(() => {
      setIsExportDisable(false)
      setExportState(month ? "Excel Absen Bulanan" : "Excel Absen Tahunan")
    });
  };

  return (
    <Button
      disabled={isExportDisable}
      onClick={() => exportAbsen()}
      className={"text-truncate"}
      title={exportState}
    >
      {exportState}
    </Button>
  );
};

export default ExportAbsen;
